import { render, staticRenderFns } from "./KeyTwenty.vue?vue&type=template&id=e86c2054&scoped=true&"
import script from "./KeyTwenty.vue?vue&type=script&lang=js&"
export * from "./KeyTwenty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e86c2054",
  null
  
)

export default component.exports